import Agent from "infrastructure/agent";
import { MarkerMapper } from "features/planner/planner.mappers";

const getMarkers = () => Agent.get(`/marker`);

const getMarker = markerId => Agent.get(`/marker/${markerId}`);

const createMarker = marker => Agent.post(`/marker`, MarkerMapper.to(marker));

const updateMarker = (markerId, marker) =>
  Agent.put(`/marker/${markerId}`, MarkerMapper.to(marker));

const deleteMarker = markerId => Agent.delete(`/marker/${markerId}`);

export default {
  getMarker,
  getMarkers,
  deleteMarker,
  createMarker,
  updateMarker,
};
